import { MultiSelect } from "primereact/multiselect";
import "./style.scss";

const MultiSelectUI = ({ className = "", ...props }) => {
    return <MultiSelect {...props} className={`multiselect-ui ${className}`} />;
};

export default MultiSelectUI;
